/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ApplicationInsights, IAppInsights } from "@microsoft/applicationinsights-web";
import { environment } from "../environment";
import ConnectionStringLoader from "./ConnectionStringLoader";
import DisabledApplicationInsights from "./DisabledApplicationInsights";
import TelemetryClient from "./TelemetryClient";

const applicationInsightsPromise: Promise<IAppInsights> = new ConnectionStringLoader()
    .ladeConnectionString()
    .then((connectionString) => {
        if (connectionString !== null) {
            const appInsights = new ApplicationInsights({
                config: {
                    connectionString: connectionString,
                    autoTrackPageVisitTime: true,
                    enableAutoRouteTracking: true,
                    disableExceptionTracking: true
                },
            });
            appInsights.loadAppInsights();
            appInsights.addTelemetryInitializer((item) => {
                item.data = item.data ?? [];
                item.data.pfad = window.location.href;
                item.data.mandantKennung = environment.mandant;
            });
            return appInsights.appInsights;
        }

        return new DisabledApplicationInsights();
    });

const applicationInsightsTelemetryClient = new TelemetryClient(applicationInsightsPromise);
export default applicationInsightsTelemetryClient;
